import {SelectItem} from "oca-lib-web";
import AppStoreConnectDataAccess from "../data/AppStoreConnectDataAccess";
import FlurryDataAccess from "../data/FlurryDataAccess";
import GoogleAnalyticsDataAccess from "../data/GoogleAnalyticsDataAccess";

export default class Constants {

    public static FONT_FAMILY = "Open Sans";
    public static WHITE_COLOR = "#ffffff";
    public static BLACK_COLOR = "#000000"
    public static BLUE_COLOR = "#1564FF";
    public static LIGHT_BLUE_COLOR = "#D2E3FE";
    //public static LIGHT_BLUE_COLOR = "#0783D5";
    public static RED_COLOR = "#DC503B";
    public static GRAY_COLOR = "#9e9fba";
    public static TRANSPARENT_COLOR = "transparent";
    public static LIGHT_GRAY_COLOR = "#D8D8D8";
    public static DARK_GRAY_COLOR = "#7b7b7b";

    public static DEFAULT_GRAPH_COLOR = "blue";

    public static EVENT_SCREEN_VIEW = "ScreenView";
    public static EVENT_NOTIFICATION = "Notification";
    public static EVENT_USER_SESSION = "UserSession";

    public static PARAM_SCREEN_NAME = "screenName";
    public static PARAM_ASSET_NAME = "assetName";
    public static PARAM_USER_ID = "userId";
    public static PARAM_ACCOUNT_ID = "accountId";

    public static CURRENT = "current";
    public static PREVIOUS = "previous";

    public static DATE_INTERVAL_DAY = "day";
    public static DATE_INTERVAL_MONTH = "month";

    public static APP_IOS = "ios";
    public static APP_ANDROID = "android";

    public static CACHE_PROJECT_ID = "projectId";
    public static CACHE_DATE = "local_date";
    public static CACHE_ANALYTICS_SETTINGS = "analytics_settings";
    public static CACHE_CURRENT_PAGE = "current_page";
    public static CACHE_LINKEDIN_ACCESS_TOKEN = "linkedin_access_token";
    public static CACHE_CUSTOM_DATE = "custom_date";

    public static AXIS_DATE = "date";

    public static METRIC_COUNT = "count";

    public static AGGREGATION_AVERAGE = "average";
    public static AGGREGATION_SUM = "sum";

    public static CHART_TYPE_BAR = "barChart";
    public static CHART_TYPE_DONUT = "donutChart";
    public static CHART_TYPE_GEO = "geo";
    public static CHART_TYPE_LINE = "lineChart";
    public static CHART_TYPE_LIST = "listTable";
    public static CHART_TYPE_SUMMARY = "summary";
    public static CHART_TYPE_TEXT = "text";
    public static CHART_TYPE_WORDCLOUD = "wordcloud";

    public static chartTypes:Array<SelectItem> = [
        SelectItem.create(Constants.CHART_TYPE_BAR, "Bar chart"),
        SelectItem.create(Constants.CHART_TYPE_DONUT, "Donut chart"),
        SelectItem.create(Constants.CHART_TYPE_GEO, "Geo map"),
        SelectItem.create(Constants.CHART_TYPE_LINE, "Line chart"),
        SelectItem.create(Constants.CHART_TYPE_LIST, "List table"),
        SelectItem.create(Constants.CHART_TYPE_SUMMARY, "Summary box"),
        SelectItem.create(Constants.CHART_TYPE_TEXT, "Text"),
        SelectItem.create(Constants.CHART_TYPE_WORDCLOUD, "Word Cloud")
    ];

    public static sortOrder:Array<SelectItem> = [
        SelectItem.create(null, "None"),
        SelectItem.create("ascending", "Ascending"),
        SelectItem.create("decending", "Decending"),
    ];

    /*public static GRAPH_TYPE_SUMMARY = "summary";
    public static GRAPH_TYPE_DETAIL = "detail";
    public static graphTypes:Array<SelectItem> = [
        SelectItem.create(Constants.GRAPH_TYPE_SUMMARY, "Summary"),
        SelectItem.create(Constants.GRAPH_TYPE_DETAIL, "Detail")
    ];*/

    public static DATA_SOURCE_APP_STORE_CONNECT = "appstore";
    public static DATA_SOURCE_FLURRY = "flurry";
    public static DATA_SOURCE_GOOGLE_ANALYTICS = "googleanalytics";
    public static DATA_SOURCE_GOOGLE_PLAY = "googleplay";
    public static DATA_SOURCE_FACEBOOK = "facebook";
    public static DATA_SOURCE_LINKEDIN = "linkedin";
    public static DATA_SOURCE_TWITTER = "twitter";
    public static DATA_SOURCE_CUSTOM = "custom";

    public static DATA_SOURCES:Array<SelectItem> = [
        SelectItem.create(Constants.DATA_SOURCE_APP_STORE_CONNECT, "App Store Connect"),
        SelectItem.create(Constants.DATA_SOURCE_FLURRY, "Flurry"),
        SelectItem.create(Constants.DATA_SOURCE_GOOGLE_ANALYTICS, "Google Analytics"),
        SelectItem.create(Constants.DATA_SOURCE_GOOGLE_PLAY, "Google Play"),
        SelectItem.create(Constants.DATA_SOURCE_FACEBOOK, "Facebook"),
        SelectItem.create(Constants.DATA_SOURCE_LINKEDIN, "LinkedIn"),
        SelectItem.create(Constants.DATA_SOURCE_TWITTER, "Twitter"),
        SelectItem.create(Constants.DATA_SOURCE_CUSTOM, "Custom"),
    ]

    public static DATA_SETS:Array<SelectItem> = [
        SelectItem.create(AppStoreConnectDataAccess.APPDOWNLOADS, "App Stores"),
        SelectItem.create(FlurryDataAccess.APPUSAGE, "Flurry - App Usage"),
        SelectItem.create(FlurryDataAccess.EVENTPARAMS, "Flurry - Event Params"),
        SelectItem.create(GoogleAnalyticsDataAccess.PAGEVIEWS, "Google Analytics - Page Views"),
        SelectItem.create(GoogleAnalyticsDataAccess.TRAFFICSOURCES, "Google Analytics - Traffic Sources"),
        SelectItem.create(GoogleAnalyticsDataAccess.USERSESSIONS, "Google Analytics - User Sessions")
    ];

    public static DATE_OPTIONS:Array<SelectItem> = [
        SelectItem.create("last7days", "Last 7 Days"),
        SelectItem.create("last14days", "Last 14 Days"),
        SelectItem.create("thisMonth", "This Month"),
        SelectItem.create("lastMonth", "Last Month"),
        SelectItem.create("twoMonths", "2 Months"),
        SelectItem.create("last3Months", "3 Months"),
        SelectItem.create("last6Months", "6 Months"),
        SelectItem.create("last12Months", "12 Months"),
        SelectItem.create("thisYear", "This Year"),
        SelectItem.create("lastYear", "Last Year"),
        SelectItem.create("custom", "Custom"),
    ]
}